// extracted by mini-css-extract-plugin
export default {"lenkePanel":"Lenkepanel_lenkePanel__mSa5q","ikon":"Lenkepanel_ikon__kOqVc"};